import {RadiusOption} from '@mgp-fe/shared/modules/partner-locator/domain.ts';

export const radiusOptions: RadiusOption[] = [
	{value: 25, zoom: 9},
	{value: 50, zoom: 8},
	{value: 100, zoom: 7},
];